const subText = [
  {
    subText1: '下午 2:30 场',
    subText2: '奖金 20,000',
    subText1En: '2:30pm',
    subText2En: 'CNY 20,000'
  },
  {
    subText1: '下午 4:30 场',
    subText2: '奖金 50,000',
    subText1En: '4:30pm',
    subText2En: 'CNY 50,000'
  },
  {
    subText1: '下午 8:00 场',
    subText2: '奖金 50,000',
    subText1En: '8:00pm',
    subText2En: 'CNY 50,000'
  },
  {
    subText1: '下午 9:30 场',
    subText2: '奖金 100,000',
    subText1En: '9:30pm',
    subText2En: 'CNY 100,000'
  }
];

const subText2 = [
  {
    subText1: '下午 2:30 场',
    subText2: '奖金 20,000',
    subText1En: '2:30pm',
    subText2En: 'CNY 20,000'
  },
  {
    subText1: '下午 4:30 场',
    subText2: '奖金 100,000',
    subText1En: '4:30pm',
    subText2En: 'CNY 100,000'
  },
  {
    subText1: '下午 8:00 场',
    subText2: '奖金 100,000',
    subText1En: '8:00pm',
    subText2En: 'CNY 100,000'
  },
  {
    subText1: '下午 9:30 场',
    subText2: '奖金 100,000',
    subText1En: '9:30pm',
    subText2En: 'CNY 100,000'
  }
];

const subText3 = [
  {
    subText1: '下午 2:30 场',
    subText2: '奖金 30,000',
    subText1En: '2:30pm',
    subText2En: 'CNY 30,000'
  },
  {
    subText1: '下午 8:00 场',
    subText2: '奖金 80,000',
    subText1En: '8:00pm',
    subText2En: 'CNY 80,000'
  }
];

const subText4 = [
  {
    subText1: '下午 2:30 场',
    subText2: '奖金 30,000',
    subText1En: '2:30pm',
    subText2En: 'CNY 30,000'
  },
  {
    subText1: '下午 8:00 场',
    subText2: '奖金 80,000',
    subText1En: '8:00pm',
    subText2En: 'CNY 80,000'
  }
];

// For day 1 of tournament for the month. Align names with indexes of subText
// Most recent tournament first
const rankingsData1 = [
  ['y***a22', '明洪'],
  ['百万梦想家', 'j***827'],
  ['I***270', 'p***600'],
  ['跌赢', '我太难了'],
  ['平凡', '8***536', '追龙', '让上一次岸'],
  ['万丈荣光', '牛牛牛', '天天好运', '稳住过两关'],
  ['每天赢二百', '飞飞飞', 'K***674', '癞子哥哥'],
  ['發發發', 'e***907', '吃吃吃', '鱼跃龙门'],
  ['h***698', '上不了的岸', '悔罪', '马户和又鸟'],
  ['G***596', 'q***644', '东北西门庆', 'n***g36']
];

// For day 2 of tournament for the month. Align names with indexes of subText
// Most recent tournament first
const rankingsData2 = [
  ['-'],
  ['赌圣'],
  ['万里长虹', '一枪过'],
  ['l***526', '赢点生活费'],
  ['b***rk2', 't***106', 'd***904', '不要浪'],
  ['小小小發發', '最近有点崩', 'm***sdt', '两百就走'],
  ['d***o75', 'x***789', 'M***989', 's***nxc'],
  ['慢慢来', 'x***757', 's***edc', '赌神上身'],
  ['红红红', 'g***259', '幸运女神', 'd***901'],
  ['我在哪', 'r***qbv', '一路长虹', 'f***yxb']
];
const rankingsData3 = [
  [],
  [],
  ['x***918', 'p***290'],
  [],
  [],
  [],
  [],
  [],
  []
];
const rankingsData4 = [
  [],
  [],
  ['a***406', 'k***212'],
  [],
  [],
  [],
  [],
  [],
  []
];

const subText2025Sep = [
  // 第1行 - 玩家1
  {
    subText1: '下午 2:30 场',
    subText2: '奖金 30,000',
    subText1En: '9/2 10:00pm',
    subText2En: 'CNY 50,000'
  },
  // 第1行 - 玩家2
  {
    subText1: '下午 3:00 场',
    subText2: '奖金 35,000',
    subText1En: '9/4 10:00pm',
    subText2En: 'CNY 80,000'
  },
  // 第2行 - 玩家1
  {
    subText1: '下午 4:30 场',
    subText2: '奖金 50,000',
    subText1En: '9/9 10:00pm',
    subText2En: 'CNY 50,000'
  },
  // 第2行 - 玩家2
  {
    subText1: '下午 5:00 场',
    subText2: '奖金 55,000',
    subText1En: '9/11 10:00pm',
    subText2En: 'CNY 80,000'
  },
  // 第3行 - 玩家1
  {
    subText1: '下午 6:30 场',
    subText2: '奖金 60,000',
    subText1En: '9/16 10:00pm',
    subText2En: 'CNY 50,000'
  },
  // 第3行 - 玩家2
  {
    subText1: '下午 7:00 场',
    subText2: '奖金 65,000',
    subText1En: '9/18 10:00pm',
    subText2En: 'CNY 80,000'
  },
  // 第4行 - 玩家1
  {
    subText1: '下午 8:00 场',
    subText2: '奖金 80,000',
    subText1En: '9/23 10:00pm',
    subText2En: 'CNY 50,000'
  },
  // 第4行 - 玩家2
  {
    subText1: '下午 8:30 场',
    subText2: '奖金 85,000',
    subText1En: '9/25 10:00pm',
    subText2En: 'CNY 80,000'
  }
];

const subText2025Dec = [
  // 第1行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 200,000',
    subText1En: '12/9 10:00pm',
    subText2En: 'CNY 200,000'
  },
  // 第1行 - 玩家2
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 200,000',
    subText1En: '12/11 10:00pm',
    subText2En: 'CNY 200,000'
  },
  // 第2行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 200,000',
    subText1En: '12/16 10:00pm',
    subText2En: 'CNY 200,000'
  },
  // 第2行 - 玩家2
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 200,000',
    subText1En: '12/18 10:00pm',
    subText2En: 'CNY 200,000'
  }
];

const subText2026Jun = [
  // 第1行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 10,000',
    subText1En: '6/2 10:00pm',
    subText2En: 'CNY 10,000'
  },
  // 第1行 - 玩家2
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 10,000',
    subText1En: '6/3 10:00pm',
    subText2En: 'CNY 10,000'
  },
  // 第2行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 1,000,000',
    subText1En: '6/10 10:00pm',
    subText2En: 'CNY 1,000,000'
  }
];

const subText2026Jul = [
  // 第1行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 10,000',
    subText1En: '7/1 10:00pm',
    subText2En: 'CNY 10,000'
  },
  // 第1行 - 玩家2
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 10,000',
    subText1En: '7/2 10:00pm',
    subText2En: 'CNY 10,000'
  },
  // 第2行 - 玩家1
  {
    subText1: '下午 10:00 场',
    subText2: '奖金 1,000,000',
    subText1En: '7/8 10:00pm',
    subText2En: 'CNY 1,000,000'
  }
];

export {
  rankingsData1, rankingsData2, rankingsData3, rankingsData4, subText,
  subText2, subText3, subText4, subText2025Sep, subText2025Dec, subText2026Jun,
  subText2026Jul
};
